<template>
  <div v-html="content"></div>
</template>

<script>
import { getCsRuleContent } from "@/api/join";
export default {
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    getCsRuleContent({ type: this.GetQueryString("type") }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.content = res.content.content;
      }
    });
  },
  beforeRouteEnter(to, from, next) {
    let title;
    switch (to.query.type) {
      case "12":
        title = "店长用户协议";
        break;
      case "13":
        title = "悦买用户协议";
        break;
      case "24":
        title = "隐私政策协议";
        break;
      default:
        title = "操作手册";
      break;
    }
    to.meta.title = title;
    document.title = title;
    next();
  },
};
</script>

<style>
</style>